import axios from 'axios'

const RESET = 'RESET'
const setContinuousDataConfigQueryOption = 'setContinuousDataConfigQueryOption'
const setContinuousDataConfigImportOption = 'setContinuousDataConfigImportOption'

const BASE_URL_GetQueryConfigOption = 'api/ContinuousData/GetQueryConfigOption/'
const BASE_URL_GetImportConfigOption = 'api/ContinuousData/GetImportConfigOption'
const BASE_URL_UpdateConfigOption = 'api/ContinuousData/UpdateConfigOption'


function initialState() {
  return {
    ContinuousDataConfigQueryOption: {},
    ContinuousDataConfigImportOption: {},
  }
}

export default {
  namespaced: true,

  state: initialState,

  actions: {
    async getContinuousDataConfigQueryOption({ commit }, options) {
      let url = BASE_URL_GetQueryConfigOption + options
      try {
        let res = await axios.get(url)
        commit(setContinuousDataConfigQueryOption, res.data)
      } catch (err) {
        console.error(err)
      }
    },
    async getContinuousDataConfigImportOption({ commit }) {
      let url = BASE_URL_GetImportConfigOption
      try {
        let res = await axios.get(url)
        commit(setContinuousDataConfigImportOption, res.data)
      } catch (err) {
        console.error(err)
      }
    },
    updateContinuousDataConfigOption({ commit }, options) {
      let url = BASE_URL_UpdateConfigOption
      return axios.post(url, options.data)
        .then((res) => {
          if (options.data.ConfigurationType == 'Query') {
            commit(setContinuousDataConfigQueryOption, res.data)
          } else {
            commit(setContinuousDataConfigImportOption, res.data)
          }
        })
        .catch((error) => {
          console.error(error)
          throw error.response.data.Message
        })
    },
  },

  mutations: {
    [RESET](state) {
      const s = initialState()
      Object.keys(s).forEach(key => {
        state[key] = s[key]
      })
    },
    [setContinuousDataConfigQueryOption](state, data) {
      state.ContinuousDataConfigQueryOption = data
    },
    [setContinuousDataConfigImportOption](state, data) {
      state.ContinuousDataConfigImportOption = data
    },
  },

  getters: {
    ContinuousDataConfigQueryOption: state => state.ContinuousDataConfigQueryOption,
    ContinuousDataConfigImportOption: state => state.ContinuousDataConfigImportOption,
  },
}